import { SurveyBuilderRouteNames } from '@/routes/constants/location'
import { RouteConfig } from 'vue-router'
import { requireAuthAndLocation } from '../auth'


const SurveyRoot = () =>
  import('@/pmd/pages/marketing/SurveyRoot.vue').then(m => m.default)

const SurveyBuilderPage = () =>
  import('@/pmd/pages/marketing/SurveyBuilderPage.vue').then(m => m.default)

const SurveyList = () =>
  import(
    /* webpackChunkName: "m-survey-list" */ '@/pmd/pages/marketing/SurveyList.vue'
  ).then(m => m.default)

const SurveySubmissionPage = () =>
  import('@/pmd/pages/marketing/SurveySubmissionPage.vue').then(m => m.default)

const EmbedSurvey = () =>
  import(
    /* webpackChunkName: "m-embed-survey" */ '@/pmd/pages/marketing/EmbedSurvey.vue'
  ).then(m => m.default)

const Analytics = () =>
  import(/* webpackChunkName: "domain-settings" */ '@/pmd/pages/analytics/FunnelWebsiteAnalytics.vue').then(
    m => m.default
  )
  
export const SurveyBuilderRoutes: RouteConfig[] = [
  {
    path: 'survey-builder',
    name: SurveyBuilderRouteNames.default,
    component: SurveyRoot,
    beforeEnter: requireAuthAndLocation,
    children: [
      {
        path: 'main',
        name: SurveyBuilderRouteNames.main,
        component: SurveyBuilderPage,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'analyze',
        redirect: to => {
          const query = {
            type: to.query.type || 'survey',
            tab: to.query.tab || 'total_views',
          }
          return {
            path: `/v2/location/${to.params.location_id}/analytics`,
            query,
          }
        },
        name: SurveyBuilderRouteNames.analyze,
        component: Analytics,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'submissions',
        name: SurveyBuilderRouteNames.submissions,
        component: SurveySubmissionPage,
        beforeEnter: (to, from, next) => {
          requireAuthAndLocation(to, from, () => {
            sessionStorage.removeItem('store')
            next()
          })
        },
      },
    ],
  },
  {
    path: 'survey-builder/:survey_id?/integrate',
    name: SurveyBuilderRouteNames.integrate,
    component: EmbedSurvey,
    beforeEnter: requireAuthAndLocation,
  },
]
